import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
@Injectable({
    providedIn: 'root',
})
export class ToasterService {
    constructor(private readonly messageService: MessageService) {}

    /**
     * Displays a success toast message.
     * @param message - The success message to display.
     */
    showSuccess(message: string) {
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: message,
            life: 3000,
        });
    }

    /**
     * Displays a warning toast message.
     * @param message - The warning message to display.
     */
    showWarning(message: string) {
        this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: message,
            life: 3000,
        });
    }

    /**
     * Displays an error toast message.
     * @param message - The error message to display.
     */
    showError(message: string) {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: message,
            life: 3000,
        });
    }
}
